import { Component, OnInit, Inject, Input } from '@angular/core';
import { AbstractComponent } from '../../../core/common/component/AbstractComponent';

@Component({
  selector: 'gs-icon',
  templateUrl: './GSIcon.html',
  styleUrls: ['./GSIcon.scss'],
})
export class GSIconComponent extends AbstractComponent {
  @Input('type')
  public type: string = 'SUCCESS';

  constructor() {
    super();
  }

  public render() {}
}
